import Flicking from '@egjs/react-flicking'
import { Link } from 'gatsby'
import React, { useRef } from 'react'
import { usePathPrefix } from '../../hooks/usePathPrefix'
import { useTranslations } from '../../hooks/useTranslations'
import ArticleTag from '../atoms/ArticleTag'
import { useParallaxCalculation } from '../../hooks/useParallax'
import { motion } from 'framer-motion'

const MagazinFeatureArticle = ({
  title,
  slug,
  image,
  lead,
  authorPhotographer,
  readTime,
  themes,
  onThemeSelected,
}) => {
  const pathPrefix = usePathPrefix()
  const translations = useTranslations()
  const ref1 = useRef(null)
  const ref2 = useRef(null)
  const ref3 = useRef(null)
  const { yRef1, yRef2, recalculateParallax } = useParallaxCalculation({
    ref1,
    ref2,
    minTranslate: 10,
  })
  const { yRef2: yRef3, recalculateParallax: recalculateParallax2 } =
    useParallaxCalculation({ ref1, ref2: ref3, minTranslate: 10 })

  return (
    <section className="mt-16 overflow-hidden md:mt-32">
      <div className="container">
        <div className="row-type-d">
          <div className="md:hidden col-2-type-d2" ref={ref3}>
            <motion.img
              src={image?.url}
              alt={title}
              style={{ y: yRef3 }}
              onLoad={recalculateParallax2}
              className="w-full h-auto mb-6 shadow-tpmp lg:shadow-dp"
            />
          </div>
          <motion.div className="col-1-type-d2" ref={ref1} style={{ y: yRef1 }}>
            <div className="mb-4 lg:mb-7 column-indent text-[15px] leading-[18px]">
              {authorPhotographer}
              <br />
              {readTime} {translations.minsReadingTime}
            </div>
            <h1 className="mb-5 u-h1-mag">
              <Link
                to={`${pathPrefix}/lift-storys/${slug}`}
                className="underline transition-colors hover:text-red-as"
              >
                {title}
              </Link>
            </h1>
            <div className="flex sm:hidden mb-5 lg:mb-6 -ml-1.5 column-indent">
              <Flicking autoInit align="prev">
                {themes?.map(({ title, id }) => (
                  <div className="inline-flex">
                    <ArticleTag
                      key={id}
                      label={title}
                      onClick={() => onThemeSelected(title)}
                    />
                  </div>
                ))}
              </Flicking>
            </div>
            <div className="items-center mb-6 -ml-1.5 column-indent flex-wrap hidden sm:flex">
              {themes?.map(({ title, id }) => (
                <ArticleTag
                  key={id}
                  label={title}
                  onClick={() => onThemeSelected(title)}
                />
              ))}
            </div>
            <p
              className="u-p column-indent link-wrapper"
              dangerouslySetInnerHTML={{ __html: lead }}
            />
          </motion.div>
          <div className="hidden col-2-type-d2 md:block" ref={ref2}>
            <motion.img
              src={image?.url}
              alt={title}
              style={{ y: yRef2 }}
              onLoad={recalculateParallax}
              className="w-full h-auto shadow-tpmp lg:shadow-dp"
            />
          </div>
        </div>
      </div>
    </section>
  )
}

export default MagazinFeatureArticle
